import { useEffect, useState } from 'react';
export const useSetFocusOnActiveStepChanged = (active, stepperContainerElement) => {
    const [previousActive, setPreviousActive] = useState(active);
    useEffect(() => {
        if (stepperContainerElement && active !== previousActive) {
            stepperContainerElement
                .querySelector(`[data-stb-step-index="${active}"]`)
                .focus();
            setPreviousActive(active);
        }
    }, [stepperContainerElement, active, previousActive]);
};
